import { useEffect, useState } from "react";
import "../../assets/css/views/schedulingAgendas/schedulingAgendasFiles.css";
import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  FilePicker,
  Group,
  IconCheckmark,
  IconDocument,
  IconHelp,
  IconWarningAlt,
  IconX,
  Modal,
  OptionInterface,
  Select,
  SelectOption,
  Table,
  TableColumns,
  TableColumnWidth,
  TableData,
  TablePagination,
  TablePreferences,
  TableSortBy,
} from "@veneer/core";
import { ModalMessageAgenda } from "./AgendasComponent/ModalMessageAgenda";
import useDownloadFiles from "../../hooks/downloadFiles/useDownloadFiles";
import { CellFormulaValue, Workbook } from "exceljs";
import moment from "moment";
import { ICreateAgendaInBulk } from "../../models/input/agendaApi/ICreateAgendaInBulk";
import AgendaManagement from "../../services/agendaApi/agendaManagement";
import { IAppointmentTypeVisitDto } from "../../models/dto/agendaApi/IAppointmentByTypeDto";
import { FormatDate } from "../../utils/conversion";
import { ModalQuestion } from "../SellOut/SellOutComponent/ModalQuestion";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import appointmentService from "../../services/agendaApi/appointment.service";
import Loader from "../../components/Loader/loader";
import LoaderModal from "../../components/Loader/loaderModal";
import { decryptText } from "../../utils/encryptionUtils";
import { CountryEnum } from "../../models/enum/CountryEnum";

export default function SchedulingAgendasFiles() {
  type SelectValue = number | string | boolean;

  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const [openModalCreateDone, setOpenModalCreateDone] = useState(false);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [deleteModalQuestion, setDeleteModalQuestion] = useState(false);
  const [fileName, setFileName] = useState<string>("");
  const [messageError, setErrorMessage] = useState<string>("");
  const [errorFilePicker, setErrorFilePicker] = useState(false);
  const [buttonNext, setButtonNext] = useState(true);
  const { downloadFile } = useDownloadFiles();
  const [jsonDate, setJsonDate] = useState<ICreateAgendaInBulk[]>([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [disabledDeleteSelection, setDisabledDeleteSelection] =
    useState<boolean>(false);
  const [checkAgenda, setCheckAgenda] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);



  const [agendaTypeSelected, setAgendaTypeSelected] = useState<SelectValue[]>([]);
  const [disabledDownloadTemplate, setDisabledDownloadTemplate] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);


  const state: any = useSelector((state: RootState) => state.user);



  useEffect(() => {
    getAgendasByType(languageID.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageID]);

  useEffect(() => {
    if (checkAgenda.length >= 1) {
      setSelectAll(true);
      setDisabledDeleteSelection(false);
    } else {
      setDisabledDeleteSelection(true);
      setSelectAll(false);
    }

    setTableData((prevTableData) =>
      prevTableData.map((item) => ({
        ...item,
        checkbox: (
          <Checkbox
            id={String(item.appoinmentId)}
            key={item.appoinmentId}
            checked={
              checkAgenda.includes(String(item.appoinmentId))
                ? "checked"
                : "unchecked"
            }
            onChange={() => handleChangeCheck(String(item.appoinmentId))}
          />
        ),
      }))
    );
  }, [checkAgenda]);

  const columns: TableColumns[] = [
    { id: "checkbox", label: "" },
    { id: "retail", label: t("posManagement.retail") },
    { id: "subRetail", label: t("header.subRetail") },
    { id: "posCode", label: t("header.posOfCode") },
    { id: "pointOfSale", label: t("header.pointOfSale") },
    { id: "nameAdvisor", label: t("header.advisor") },
    { id: "visitType", label: t("header.typeOfVisit") },
    { id: "startDate", label: t("header.stardDate") },
    { id: "endDate", label: t("header.endDate") },
    { id: "dateVisit", label: t("header.visitDate") },
    { id: "startTime", label: t("header.startTime") },
    { id: "endTime", label: t("header.endTime") },
    { id: "monday", label: t("header.monday") },
    { id: "tuesday", label: t("header.tuesday") },
    { id: "wednesday", label: t("header.wednesday") },
    { id: "thursday", label: t("header.thursday") },
    { id: "friday", label: t("header.friday") },
    { id: "saturday", label: t("header.saturday") },
    { id: "sunday", label: t("header.sunday") },
  ];

  const columnsWidth: TableColumnWidth[] = [
    { columnId: "checkbox" },
    { columnId: "retail" },
    { columnId: "subRetail" },
    { columnId: "posCode" },
    { columnId: "pointOfSale" },
    { columnId: "nameAdvisor" },
    { columnId: "visitType" },
    { columnId: "startDate" },
    { columnId: "endDate" },
    { columnId: "dateVisit" },
    { columnId: "startTime" },
    { columnId: "endTime" },
    { columnId: "sunday" },
    { columnId: "monday" },
    { columnId: "tuesday" },
    { columnId: "wednesday" },
    { columnId: "thursday" },
    { columnId: "friday" },
    { columnId: "saturday" },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
    defaultOrder: ["visitType"],
    order: columns.map((item) => item.id),
    sortBy: { id: "visitType", type: "ascending" }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const handleSort = (
    _: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined,
    { id, type }: TableSortBy
  ) => {
    const sortedData = [...tableData].sort((a, b) => {
      if (a[id] < b[id]) {
        return type === "ascending" ? -1 : 1;
      }
      if (a[id] > b[id]) {
        return type === "ascending" ? 1 : -1;
      }
      return 0;
    });
    setTableData(sortedData);
  };

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const getAgendasByType = (languageID: number) => {
    setLoadingTable(true);
    AgendaManagement.getAppointmentsByType(languageID)
      .then((result: IAppointmentTypeVisitDto[]) => {
        fillData(result);
      })
      .finally(() => setLoadingTable(false));
  };

  const fillData = (data: any[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const appointment: IAppointmentTypeVisitDto = data[i];
      const tableData: TableData = {
        checkbox: (
          <Checkbox
            id={String(appointment.appoinmentId)}
            key={appointment.appoinmentId}
            checked={
              checkAgenda.includes(String(appointment.appoinmentId))
                ? "checked"
                : "unchecked"
            }
            onChange={() => handleChangeCheck(String(appointment.appoinmentId))}
          />
        ),
        appoinmentId: appointment.appoinmentId,
        retail: appointment.retail,
        subRetail: appointment.subRetail,
        posCode: appointment.posCode,
        pointOfSale: appointment.pointOfSale,
        nameAdvisor: appointment.fullName,
        visitType: appointment.typeOfVisit,
        startDate:
          appointment.typeOfVisitId === 2
            ? ""
            : FormatDate(appointment.stardDate, "DD/MM/YYYY"),
        endDate:
          appointment.typeOfVisitId === 2
            ? ""
            : FormatDate(appointment.endDate, "DD/MM/YYYY"),
        dateVisit:
          appointment.typeOfVisitId === 2
            ? FormatDate(appointment.dateVisit, "DD/MM/YYYY")
            : "",
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        sunday:
          appointment.sunday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        monday:
          appointment.monday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        tuesday:
          appointment.tuesday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        wednesday:
          appointment.wednesday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        thursday:
          appointment.thursday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        friday:
          appointment.friday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
        saturday:
          appointment.saturday === true ? (
            <IconCheckmark filled color="colorGreen4" size={30} />
          ) : (
            <IconX filled color="colorRed4" size={30} />
          ),
      };
      pagedData.push(tableData);
    }
    setTableData(pagedData);
  };
  const getDayOfWeek = (dateString: string): string => {
    const date = new Date(dateString);
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return daysOfWeek[date.getUTCDay()];
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target;

    if (fileInput.files) {
      setLoadingModal(true);
      const file = fileInput.files[0];
      setFileName(file.name);
      const reader = new FileReader();
      const fileType = file.name.split(".").pop();

      if (fileType?.toLowerCase() !== "xlsx") {
        setErrorMessage(t("header.messageXLSX"));
        setErrorFilePicker(true);
        return;
      } else {
        setErrorFilePicker(false);
        reader.onload = async (event) => {
          const data = event.target?.result as ArrayBuffer;
          const workbook = new Workbook();

          try {
            await workbook.xlsx.load(data);
            let agendaTypeID = 0;
            let userMap: Record<string, number> = {};
            const rows: any[] = [];

            const hiddenSheet = workbook.getWorksheet("Data");
            if (hiddenSheet) {
              agendaTypeID = Number(hiddenSheet.getCell("G1").value);
              let row = 1;
              while (hiddenSheet.getCell(`A${row}`).value && hiddenSheet.getCell(`B${row}`).value) {
                const userID = Number(hiddenSheet.getCell(`A${row}`).value);
                const userName = hiddenSheet.getCell(`B${row}`).value?.toString().trim();
                userMap[userName?.trim() || 0] = userID;
                row++;
              }
            }

            if (!agendaTypeID) {
              setErrorMessage(t("header.messageFormatError"));
              setErrorFilePicker(true);
              return;
            }

            // Visits Brasil
            if (validateBrasil(agendaTypeID)) {
              workbook.eachSheet((worksheet) => {
                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                  if (rowNumber !== 1) {
                    const dateValue = row.getCell(3).value;
                    let date: string | undefined;

                    if (typeof dateValue === "string") {
                      date = moment(dateValue, "DD/MM/YYYY", true).utc().format("YYYY-MM-DD");
                    } else if (typeof dateValue === "number") {
                      date = moment.utc(new Date((dateValue - 25569) * 86400 * 1000)).format("YYYY-MM-DD");
                    }

                    if (date && moment(date, "YYYY-MM-DD", true).isValid()) {
                      const dayOfWeek = getDayOfWeek(date);
                      const rowData = {
                        UserID: Number(row.getCell(1).value),
                        PosCode: row.getCell(2).value,
                        DateVisit: date,
                        AssignHourIn: row.getCell(4).value,
                        AssignHourOut: row.getCell(5).value,
                        Sunday: dayOfWeek === "Sunday",
                        Monday: dayOfWeek === "Monday",
                        Tuesday: dayOfWeek === "Tuesday",
                        Wednesday: dayOfWeek === "Wednesday",
                        Thursday: dayOfWeek === "Thursday",
                        Friday: dayOfWeek === "Friday",
                        Saturday: dayOfWeek === "Saturday",
                        AgendaTypeID: 2,
                      };

                      const isValid = rowData.DateVisit && rowData.AssignHourIn && rowData.AssignHourOut;

                      if (isValid) {
                        rows.push(rowData);
                      } else {
                        setButtonNext(true);
                        setErrorFilePicker(true);
                        setErrorMessage(t("modal.incorrectformatAgenda"));
                      }
                    }
                  }
                });
              });

              setJsonDate(rows);
              setButtonNext(false);
              setLoadingModal(false);
              return;
            }

            const sheet = workbook.worksheets[0];
            sheet.eachRow((row, rowNumber) => {
              if (rowNumber !== 1) {
                const asesorName = row.getCell(1).value?.toString().trim();
                let date: string | undefined;
                let startDate: string | undefined;
                let endDate: string | undefined;

                let startDateValue, endDateValue, startCellValue, endCellValue;
                let PosCode, PosList, HourIn, HourOut, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday = null;

                if (agendaTypeID === 1) {
                  startDateValue = row.getCell(5).value;
                  endDateValue = row.getCell(6).value;

                  Monday = row.getCell(9).value === "Sí";
                  Tuesday = row.getCell(10).value === "Sí";
                  Wednesday = row.getCell(11).value === "Sí";
                  Thursday = row.getCell(12).value === "Sí";
                  Friday = row.getCell(13).value === "Sí";
                  Saturday = row.getCell(14).value === "Sí";
                  Sunday = row.getCell(15).value === "Sí";

                  const posCodeCell = row.getCell(4).value;
                  PosCode = typeof posCodeCell === "object" && posCodeCell !== null &&
                    "result" in posCodeCell ? (posCodeCell as CellFormulaValue).result : posCodeCell;

                  startCellValue = row.getCell(7).value;
                  endCellValue = row.getCell(8).value;

                }
                else if (agendaTypeID === 2) {

                  const dateValue = row.getCell(5).value;
                  if (dateValue instanceof Date) {
                    date = moment(dateValue).utc().format("YYYY-MM-DD");
                  } else if (typeof dateValue === "string") {
                    date = moment(dateValue, "DD/MM/YYYY", true).utc().format("YYYY-MM-DD");
                  } else if (typeof dateValue === "number") {
                    date = moment.utc(new Date((dateValue - 25569) * 86400 * 1000)).format("YYYY-MM-DD");
                  }

                  const posCodeCell = row.getCell(4).value;
                  PosCode = typeof posCodeCell === "object" && posCodeCell !== null &&
                    "result" in posCodeCell ? (posCodeCell as CellFormulaValue).result : posCodeCell;

                  Monday = false;
                  Tuesday = false;
                  Wednesday = false;
                  Thursday = false;
                  Friday = false;
                  Saturday = false;
                  Sunday = false;


                  startCellValue = row.getCell(6).value;
                  endCellValue = row.getCell(7).value;

                } else if (agendaTypeID === 3) {
                  startDateValue = row.getCell(3).value;
                  endDateValue = row.getCell(4).value;

                  Monday = row.getCell(7).value === "Sí";
                  Tuesday = row.getCell(8).value === "Sí";
                  Wednesday = row.getCell(9).value === "Sí";
                  Thursday = row.getCell(10).value === "Sí";
                  Friday = row.getCell(11).value === "Sí";
                  Saturday = row.getCell(12).value === "Sí";
                  Sunday = row.getCell(13).value === "Sí";

                  PosList = row.getCell(2).value;

                  startCellValue = row.getCell(5).value;
                  endCellValue = row.getCell(6).value;

                }

                if (startCellValue instanceof Date) {
                  HourIn = moment.utc(startCellValue).format("HH:mm");
                } else if (typeof startCellValue === "number") {
                  HourIn = moment.utc(new Date((startCellValue - 25569) * 86400 * 1000)).format("HH:mm");
                }

                if (endCellValue instanceof Date) {
                  HourOut = moment.utc(endCellValue).format("HH:mm");
                } else if (typeof endCellValue === "number") {
                  HourOut = moment.utc(new Date((endCellValue - 25569) * 86400 * 1000)).format("HH:mm");
                }

                if (agendaTypeID !== 2) {
                  if (startDateValue instanceof Date) {
                    startDate = moment(startDateValue).utc().format("YYYY-MM-DD");
                  } else if (typeof startDateValue === "string") {
                    startDate = moment(startDateValue, "DD/MM/YYYY", true).utc().format("YYYY-MM-DD");
                  } else if (typeof startDateValue === "number") {
                    startDate = moment.utc(new Date((startDateValue - 25569) * 86400 * 1000)).format("YYYY-MM-DD");
                  }

                  if (endDateValue instanceof Date) {
                    endDate = moment(endDateValue).utc().format("YYYY-MM-DD");
                  } else if (typeof endDateValue === "string") {
                    endDate = moment(endDateValue, "DD/MM/YYYY", true).utc().format("YYYY-MM-DD");
                  } else if (typeof endDateValue === "number") {
                    endDate = moment.utc(new Date((endDateValue - 25569) * 86400 * 1000)).format("YYYY-MM-DD");
                  }
                }


                if ((date && moment(date, "YYYY-MM-DD", true).isValid()) || (startDate && endDate && moment(startDate, "YYYY-MM-DD", true).isValid() && moment(endDate, "YYYY-MM-DD", true).isValid())) {
                  const rowData = {
                    UserID: typeof asesorName === "string" ? userMap[asesorName.trim()] || 0 : 0,
                    PosCode: PosCode,
                    PosList: PosList,
                    StartDate: startDate,
                    EndDate: endDate,
                    DateVisit: date,
                    AssignHourIn: HourIn,
                    AssignHourOut: HourOut,
                    Monday: Monday,
                    Tuesday: Tuesday,
                    Wednesday: Wednesday,
                    Thursday: Thursday,
                    Friday: Friday,
                    Saturday: Saturday,
                    Sunday: Sunday,
                    AgendaTypeID: agendaTypeID,
                  };
                  const isValid =
                    (agendaTypeID === 1 && rowData.StartDate && rowData.EndDate && rowData.AssignHourIn && rowData.AssignHourOut) ||
                    (agendaTypeID === 2 && rowData.DateVisit && rowData.AssignHourIn && rowData.AssignHourOut) ||
                    (agendaTypeID === 3 && rowData.StartDate && rowData.EndDate && rowData.AssignHourIn && rowData.AssignHourOut && rowData.PosList);

                  if (isValid) {
                    rows.push(rowData);
                  } else {
                    setButtonNext(true);
                    setErrorFilePicker(true);
                    setErrorMessage(t("modal.incorrectformatAgenda"));
                  }
                }
              }
            });
            setJsonDate(rows);
          } catch (error) {
            setErrorFilePicker(true);
            setButtonNext(true);
            setErrorMessage(t("modal.errorLoadingFile"));
          }
        };
        reader.readAsArrayBuffer(file);
        setButtonNext(false);
      }
      setLoadingModal(false);
    }
  };


  const onClearFilePicker = () => {
    setFileName("");
    setErrorFilePicker(false);
    setButtonNext(true);
  };

  const handleOnClickExit = () => {
    setFileName("");
    setOpenModalCreate(false);
    setButtonNext(true);
  };

  const createAgenda = async () => {
    setLoadingModal(true);
    interface DataItem {
      userID: number;
      posCode?: string;
      startDate?: string;
      endDate?: string;
      dateVisit?: string;
      startTime?: string;
      endTime?: string;
      agendaTypeID: number;
      agendaType?: string;
      result: number;
      message?: string;
    }

    try {
      const response: any[] = await AgendaManagement.createAppointmentInBulk(jsonDate);
      if (response) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Datos");

        worksheet.columns = [
          { header: t("header.userId"), key: "userID", width: 15 },
          { header: t("header.posOfCode"), key: "posCode", width: 15 },
          { header: t("header.stardDate"), key: "startDate", width: 15 },
          { header: t("header.endDate"), key: "endDate", width: 15 },
          { header: t("header.visitDate"), key: "dateVisit", width: 20 },
          { header: t("header.startTime"), key: "startTime", width: 15 },
          { header: t("header.endTime"), key: "endTime", width: 15 },
          { header: t("header.agendaType"), key: "agendaType", width: 15 },
          { header: t("modal.message"), key: "message", width: 30 },
        ];


        response.forEach((item: DataItem) => {

          item.agendaType = item.agendaTypeID === 1 ? t("header.permanent")
            : item.agendaTypeID === 2 ? t("header.visit")
              : item.agendaTypeID === 3 ? t("header.route")
                : String(item.agendaTypeID);

          item.message = item.result === 0 ? t("modal.agendaError")
            : item.result === 1 ? t("modal.agendaOk")
              : item.result === 2 ? t("modal.agendaExist")
                : item.result === 3 ? t("modal.agendaInvalidParams")
                  : t("modal.agendaUnknown");

          if (item.startDate) item.startDate = item.startDate.split("T")[0];
          if (item.endDate) item.endDate = item.endDate.split("T")[0];
          if (item.dateVisit) item.dateVisit = item.dateVisit.split("T")[0];

          const row = worksheet.addRow(item);

          row.eachCell((cell) => {
            cell.alignment = { horizontal: "center" };
          });
        });

        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "00B0F0" } };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin", color: { argb: "000000" } },
            left: { style: "thin", color: { argb: "000000" } },
            bottom: { style: "thin", color: { argb: "000000" } },
            right: { style: "thin", color: { argb: "000000" } },
          };
          cell.font = { bold: true };
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);

        setOpenModalCreate(false);
        setOpenModalCreateDone(true);
        getAgendasByType(languageID.value);
        setCheckAgenda([]);
        setDisabledDeleteSelection(true);
        setSelectAll(false);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Agenda_Resultados.xlsx";
        a.click();

        URL.revokeObjectURL(url);
      } else {
        setOpenModalCreate(false);
        setOpenModalError(true);
      }
      setLoadingModal(false);
    } catch (error) {
      setOpenModalCreate(false);
      setOpenModalError(true);
      setLoadingModal(false);
    }
  };


  const handleCreateAgenda = () => {
    setOpenModalCreate(true);
    setFileName("");
    setErrorFilePicker(false);
    setButtonNext(true);
  };

  const handleChangeSelectAll = () => {
    if (checkAgenda.length >= 1) {
      setCheckAgenda([]);
    } else {
      const allIds = tableData.map((item) => String(item.appoinmentId));
      setCheckAgenda(allIds);
    }
  };

  const handleChangeCheck = (appoinmentId: string) => {
    setCheckAgenda((prevState) =>
      prevState.includes(appoinmentId)
        ? prevState.filter((id) => id !== appoinmentId)
        : [...prevState, appoinmentId]
    );
  };

  const deleteSelection = () => {
    AgendaManagement.deleteAppointmentInBulk(checkAgenda.join(", ")).then(
      (r) => {
        switch (r) {
          case 0: {
            setDeleteModalQuestion(false);
            setOpenModalError(true);
            break;
          }
          case 1: {
            setTableData([]);
            getAgendasByType(languageID.value);
            setDeleteModalQuestion(false);
            setOpenModalDelete(true);
            setDisabledDeleteSelection(true);
            setSelectAll(false);
            break;
          }
          default: {
            setOpenModalError(true);
            setDeleteModalQuestion(false);
          }
        }
      }
    );
  };

  const optionsTypeAgenda: SelectOption[] = [
    { value: 1, label: t("header.permanent") },
    { value: 2, label: t("header.visit") },
    { value: 3, label: t("header.route") }
  ];

  const handleDownloadTemplate = () => {
    if (!validateBrasil(Number(agendaTypeSelected))) {
      setLoading(true)
      appointmentService.getAgendaTemplate(Number(agendaTypeSelected))
        .then((r: Blob | any) => {
          try {
            if (r?.statusCode === 401) {
              console.error('Error:', "Download failed");
            } else if (r instanceof Blob) {
              try {

                var fileName = 'AgendaTemplate';

                switch (Number(agendaTypeSelected)) {
                  case 1: fileName = 'PermanentAgendaTemplate';
                    break;
                  case 2: fileName = 'VisitAgendaTemplate';
                    break;
                  case 3: fileName = 'RouteAgendaTemplate';
                    break;
                  default: fileName = 'AgendaTemplate';
                }

                const url = window.URL.createObjectURL(r);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName + '.xlsx');
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.error('Error:', error);
              }
            }
          } catch (error) {
            console.error('Error:', error);
          } finally {
            setLoading(false)
            setAgendaTypeSelected([])
          }
        })
    } else {
      downloadFile("AgendaFile.xlsx", "xlsx", "VisitAgendaTemplate")
    }
  }

  //Validate if is Brasil and type of agenda visit
  const validateBrasil = (visitType: number) => {
    const actualContry = Number(decryptText(state.user.countryId));
    if ((actualContry === CountryEnum.brasil1 || actualContry === CountryEnum.brasil2 || actualContry === CountryEnum.brasil3) && visitType === 2) {
      return true;
    } else {
      return false;
    }
  }


  useEffect(() => {
    if (agendaTypeSelected.length > 0) {
      setDisabledDownloadTemplate(false);
    } else {
      setDisabledDownloadTemplate(true);
    }
  }, [agendaTypeSelected]);


  return (
    <div className="schedulingAgendasFiles">
      {loading && <Loader />}
      <h4 className="schedulingAgendasFilesTitle">
        {t("header.schedulingAgendasFilesTitle")}
      </h4>

      <div className="schedulingAgendasFilesButtonsTemplate">
        <div>
          <Button onClick={handleCreateAgenda} style={{ margin: "5px" }}>
            {t("header.uploadFile")}
          </Button>

          <div className="tooltip">
            <span className="tooltiptext">
              {t("modal.titleHelper").replace(":", "?")}
            </span>
            <Button
              style={{ margin: "5px" }}
              appearance="secondary"
              leadingIcon={<IconHelp />}
              onClick={() => setOpenModalHelp(true)}
            ></Button>
          </div>

        </div>

        <div className="schedulingAgendasFilesButtonsTemplateRight">
          <Select
            className="schedulingAgendasFilesButtonsTemplateSelect"
            label={t("header.selectTypeAgenda")}
            options={optionsTypeAgenda}
            value={agendaTypeSelected}
            onChange={e => setAgendaTypeSelected([e.value])}
            onClear={() => setAgendaTypeSelected([])}
            placement="bottom-start"
          />

          <Button disabled={disabledDownloadTemplate} onClick={handleDownloadTemplate} style={{ margin: "5px" }}>
            {t("header.downloadTemplate")}
          </Button>
        </div>
      </div>

      {/*  
      <div className="schedulingAgendasFilesDeletion">

        <div className="schedulingAgendasFilesButtons">
          <Checkbox
            id="modalCheckbox"
            value={selectAll}
            checked={selectAll}
            onChange={handleChangeSelectAll}
            label={
              checkAgenda.length === 0
                ? t("modal.selectAll")
                : t("modal.deselectAll")
            }
            disabled={tableData.length > 1 ? false : true}
          />

          <Button
            onClick={() => setDeleteModalQuestion(true)}
            style={{ margin: "20px" }}
            disabled={disabledDeleteSelection}
          >
            {t("modal.deleteSelection")}
          </Button>
        </div>

        <div>
          <Table
            className="schedulingAgendasFilesTable"
            columnResize
            preferences={tablePreferences}
            loading={loadingTable}
            loadingDataLength={10}
            columns={columns}
            data={pagedData}
            pagination={paginationProps}
            onSort={handleSort}
            customNoItems={
              <div className="customNoItems">
                <div className="DivIconCustomNoItems">
                  <IconWarningAlt className="IconCustomNoItems" />
                </div>
                {t("header.noItemsFound")}
              </div>
            }
            behavior={{
              type: "singlePage",
            }}
          />
        </div>
      </div> */}

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openModalCreateDone}
          closeModal={setOpenModalCreateDone}
          title={t("modal.message")}
          message={t("modal.messageAgenda")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openModalError}
          closeModal={setOpenModalError}
          title={t("header.error")}
          message={t("modal.generalError")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openModalHelp}
          closeModal={setOpenModalHelp}
          title={t("modal.titleHelper")}
          message={t("modal.helperAgendas")}
        />
      </div>


      {loadingModal && <LoaderModal />}
      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          closeButton
          id="modal-Create"
          show={openModalCreate}
          onClose={handleOnClickExit}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button appearance="secondary" onClick={handleOnClickExit}>
                  {t("header.closebutton")}
                </Button>
                <Button onClick={createAgenda} disabled={buttonNext}>
                  {t("header.sendButton")}
                </Button>
              </Group>
            </div>
          }
          title={t("modal.createMassiveAgenda")}
        >
          <div>
            <h5>{t("header.uploadFile")}</h5>
            <FilePicker
              className="modalSellOutFile"
              id="selOut-file-picker"
              label={t("header.uploadFile")}
              accept=".xlsx"
              onChange={handleFileChange}
              onClear={onClearFilePicker}
              value={fileName}
              error={errorFilePicker}
              helperText={messageError}
            />
          </div>
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageAgenda
          openModal={openModalDelete}
          closeModal={setOpenModalDelete}
          title={t("modal.message")}
          message={t("modal.deleteAgendaVisit")}
        />
      </div>

      <ModalQuestion
        id="modal-Delete"
        setOpenCloseModal={() => setDeleteModalQuestion(false)}
        openModal={deleteModalQuestion}
        titleMessage={t("modal.message")}
        message={t("modal.questionDeleteAgendaVisit")}
        onClickYes={deleteSelection}
        onClickNo={() => setDeleteModalQuestion(false)}
        titleButtonYes={t("header.yes")}
        titleButtonNo={t("header.no")}
      />
    </div>
  );
}
